import { type PopperPlacementType, type SxProps, type Theme } from '@mui/material'

export type Tour = {
  name: string
  showOnPaths: string[]
  steps: Step[]
  sx?: SxProps<Theme>
}

type PopperConfig = {
  disablePortal?: boolean
  placement?: PopperPlacementType
  sx?: SxProps<Theme>
  transitionTimeout?: number
  offset?: [number, number]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- no explicit type available
  arrowOptions?: any
}

export type Step = {
  target: string
  title: string
  body: string
  highlightElement?: string
  popperConfig?: PopperConfig
  onHide?: () => void
  onShow?: () => void
}

export const defaultPopperConfig: PopperConfig = {
  disablePortal: true,
  placement: 'auto',
  transitionTimeout: 500,
  offset: [0, 24],
}
